"use strict";

//Global Options
var flatpickr_options = {
    locale: plek_lang.get_current_language(true),
    enableTime: true,
    dateFormat: "Y-m-dTH:i:S",
    altInput: true,
    altFormat: "j. F Y - H:i",
    onChange: function (selectedDates, dateStr, instance) {
        plekerror.clear_field_error(jQuery(instance.input).attr("id"));
    }
};
var flatpickr_range_options = {
    locale: plek_lang.get_current_language(true),
    mode: 'range',
    dateFormat: 'Y-m-d',
    altInput: true,
    altFormat: plek_lang.get_current_date_format(),
};


jQuery(document).ready(function () {

    //Load the Select2
    /*jQuery('select:not(.no-select2, .flatpickr-monthDropdown-months, .qm-filter)').select2({
        theme: "plek"
    });*/

    plek_main.initTomSelect();

    /** Avoid Reload on enter button press */
    /**
     * @todo: make the submit button work on select band / organi / venue item
     */
    jQuery(document).keypress(function (e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode === 13) {
            if (jQuery(e.target).hasClass("plek-submit") === false) {
                //e.preventDefault();
            }
        }
    });
});


let plek_manage_event = {

    constructed: false,
    //Options for the Band Items
    flatpickr_band_options: {
        locale: "de",
        enableTime: true,
        dateFormat: "Y-m-d H:i:S",
        altInput: true,
        altFormat: "j.m H:i",
        onChange: function (selectedDates, dateStr, instance) {
            plek_manage_event.set_button_time(instance);
        }
    },
    existing_vob_data: {},
    is_edit_event: false,

    __construct() {
        if (this.constructed === true) {
            return;
        }
        this.constructed = true;

        this.add_event_listeners();
        ajaxPreloader('bands');
        ajaxPreloader('venues');
        ajaxPreloader('organizers');

        //On Ready
        jQuery(document).ready(function () {
            plek_manage_event.prepare_validator_fields();
            plekvalidator.monitor_fields();

            //Load the Flatpickr
            try {
                flatpickr("#event_start_date", flatpickr_options);
                flatpickr("#event_end_date", flatpickr_options);
            } catch (error) {
                console.error("Flatpickr not loaded");
            }

            //Populate the existing vob data
            plek_manage_event.add_vob_to_current_selection('bands');
            plek_manage_event.add_vob_to_current_selection('venue');
            plek_manage_event.add_vob_to_current_selection('organizers');

            //Load the error class
            plekerror.set_toastr();
        });



        //Check if edit event is populated. If so, it is the edit event form or the add details form
        if (!empty(plekevent.get_field_value('event_id'))) {
            this.is_edit_event = true;
        }

        //Hide the is postponed field
        jQuery('.event-date-postponed-check-container').hide();
    },

    /**
     * The Instance from flatpickr
     * This function should run as a callback on flatpickr Change
     * @param {*} flatpickr_instance 
     */
    set_button_time(flatpickr_instance) {
        let date = jQuery(flatpickr_instance.element).next().val();
        if (date.length === 0) {
            return false;
        }
        if (!plekevent.event_is_single_day()) {
            //Event is multiday
            if (typeof plek_manage_event.flatpickr_band_options.enable[0] !== 'undefined' && plek_manage_event.flatpickr_band_options.enable[0].from === plek_manage_event.flatpickr_band_options.enable[0].to) {
                //Is Single day. Only display the time
                date = (typeof date.split(' ')[1] !== 'undefined') ? date.split(' ')[1] : date;
            }
        }
        jQuery(flatpickr_instance.element).parent().find('.time-label').text(date);
        return;
    },

    add_event_listeners() {

        jQuery(window).on('beforeunload', function (event) {
            plek_manage_event.beforeUnloadPage(event);
        });

        //On Save Band / Organizer / Venue
        jQuery('.overlay_content .plek-form').on('click', '.plek-button', function (e) {
            let button_id = e.currentTarget.id;
            e.preventDefault();
            plek_manage_event.send_vob_form(button_id);
        });

        jQuery('.plek-form').on('click', '.plek-button-cancel', function (e) {
            let button_id = e.currentTarget.id;
            e.preventDefault();
            plek_manage_event.vob_form_cancel(button_id);
        });
        //Event Listener
        //Date-Time
        jQuery('#is_multiday').click(function () {
            if (jQuery(this).is(':checked')) {
                show_end_date();
            } else {
                hide_end_date();
            }
            plekevent.set_band_time_flatpickr(); //Updates the band times, if time changed
        });
        //Show the enddate if checkbox is preselected
        if (jQuery('#is_multiday').is(':checked')) {
            show_end_date();
        }

        jQuery('#no_band').click(function () {
            if (jQuery(this).is(':checked')) {
                disable_band_input();
                jQuery('#event-band-selection').hide();
                //plekevent.remove_all_items('event-band-selection');
            } else {
                jQuery('#event-band-selection').show();
                enable_band_input();
            }
        });

        //On change of the start date
        jQuery('#event_start_date').change(function () {
            var start_date = jQuery('#event_start_date').val();
            var end_date = jQuery('#event_end_date').val();
            var end_options = flatpickr_options;
            //Check if the new startdate is before the enddate.
            let startDD = new Date(start_date);
            let endDD = new Date(end_date);
            if (startDD > endDD) { //if startdate is bigger than enddate, reset the enddate.
                jQuery('#event_end_date').val(''); //Reset the Enddate
            }
            end_options['minDate'] = start_date;
            try {
                flatpickr("#event_end_date", end_options);
            } catch (error) {
                console.error("Flatpickr not loaded");
            }
            //Show checkbox if date was changed and edit event
            if (plek_manage_event.is_edit_event) {
                jQuery('.event-date-postponed-check-container').show();
            }
        });

        //On change of the start or enddate
        jQuery('.date-input-container input').change(function () {
            plekevent.set_band_time_flatpickr(); //Updates the band times, if time changed
        });

        jQuery('#plek-submit-basic-event').click(async function (event) {
            event.preventDefault();
            jQuery(this).prop("disabled", true);
            var type = jQuery(this).data("type");
            var form = 'add_event_basic';
            if (type === 'new_event_next_page') {
                let url = jQuery(this).data("url");
                window.location = url;
                return;
            }
            await window.plekevent.save_event(type, form);
            jQuery(this).prop("disabled", false);
        });

        jQuery('#plek-submit-event-details').click(function (event) {
            event.preventDefault();
            jQuery(this).prop("disabled", true);
            var type = jQuery(this).data("type");
            var form = 'add_event_details';
            window.plekevent.save_event(type, form);
        });

        jQuery('#plek-submit-event-edit').click(function (event) {
            event.preventDefault();
            jQuery(this).prop("disabled", true);
            var type = jQuery(this).data("type");
            var form = 'edit_event_form';
            window.plekevent.save_event(type, form);
        });

        /* Guest Login */
        jQuery('#main').on('click', "#plek-add-login-submit", function (event) {
            event.preventDefault();
            jQuery(this).prop("disabled", true);
            var type = jQuery(this).data("type");
            window.plekevent.save_event_login(type);
        });

        /* User Login */

        jQuery('#main').on('click', ".plek-add-event-login.plek-form #wp-submit", function (event) {
            event.preventDefault();
            const button = '.plek-add-event-login.plek-form #wp-submit';
            jQuery(button).prop("disabled", true);
            var type = 'save_add_event_login_user';
            window.plekevent.save_event_login(type, button, 'loginform');
        });


        jQuery("#plek-submit-event-edit-review").on('click', (event) => {
            event.preventDefault();
            jQuery(this).prop("disabled", true);
            //Checks if the review is about to be published and if there are any sm images present
            if (document.querySelector('#publish_review')?.checked && plek_manage_event.check_sm_images() === false) {
                plekerror.display_error('', __('Failed to publish the review. Please upload the social media images first.', 'plekvetica'), __('Oh no!', 'plekvetica'));
                return false;
            }
            if (document.querySelectorAll('.plek-spellchecker-container button').length > 0) {
                plekerror.display_error('', __('Failed to publish the review. There is a spellchecker active. Please apply or cancel the spellchecker before saving.', 'plekvetica'), __('Oh no!', 'plekvetica'));
                return false;
            }
            plekevent.save_review();
        });

        /** Display and position the Output container */
        jQuery('.plek-search-input').focus(function (element) {
            plektemplate.hide_overlay();
            plektemplate.show_overlay(this);
        });

        jQuery('.plek-search-input').keyup(function (element) {
            var input_length = jQuery(this).val().length;
            if (input_length === 0) {
                window.plektemplate.hide_overlay();
                return;
            }
            pleksearch.fire_search(this);
        });

        jQuery('.event-organizer-proposal-item').click(function (element) {
            window.plekevent.add_item_to_selection(this, 'event-organizer-selection');
        });

        jQuery('.event-band-container').on('click', '#no_band', function (element) {
            var checked = jQuery(this).is(':checked');
            plekvalidator.add_field('event_band', 'int', checked, 'add_event_basic'); //Toggles the requirement of the band field
        });

        //Clear the errors
        jQuery('input').on('keyup', function () {
            plekerror.clear_field_error(jQuery(this).attr("id"));
        });

        //Add Login Stage Event listener
        jQuery('#main').on('click', '#add_as_guest', function (e) {
            plek_add_event_functions.show_guest_login(e);
        });
        jQuery('#main').on('click', '#add_login', function (e) {
            plek_add_event_functions.show_login_form(e);
        });
        //Add Login Stage Event listener
        jQuery('#main').on('keydown', '#add_as_guest', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                plek_add_event_functions.show_guest_login(e);
            }
        });
        jQuery('#main').on('keydown', '#add_login', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                plek_add_event_functions.show_login_form(e);
            }
        });

        jQuery('.plek-search-overlay').on('click', '.add-new-vob-button', function (e) {
            plek_add_event_functions.show_vob_form(e.currentTarget.id);
        });

        //Add date to ticket giveaway
        jQuery('#event_ticket_raffle_conditions').on('change', () => {
            plek_manage_event.add_ticket_giveaway_date();
        });

        //Do spellcheck
        jQuery('.plek_spellchecker').on('click', (e) => {
            e.preventDefault();
            const target = jQuery(e.currentTarget).data('target');
            plek_main.do_spellcheck(jQuery('#' + target), e.currentTarget);
        });

        //Manage heartbeat
        jQuery(document).on('heartbeat-send', function (event, data) {
            const event_id = jQuery('#event_id').val();
            data.plek_post_id = event_id;
            return data;
        });
    },

    /**
     * Sends the vob (Venue, Organizer, Band) form
     * @todo: On add vob, check if vob does not exist (while the form is getting filled out)
     * @param {string} type - Type to send 
     */
    send_vob_form(type = null) {
        var data = jQuery('#' + type).serialize();
        if (typeof data === 'undefined') {
            return false;
        }
        let vob_form_name = ''; //band, venue or organizer
        switch (type) {
            case 'band-form-submit':
                vob_form_name = 'band';
                break;
            case 'venue-form-submit':
                vob_form_name = 'venue';
                break;
            case 'organizer-form-submit':
                vob_form_name = 'organizer';
                break;
            default:
                console.error('type not supported:' + type);
                return false;
                break;
        }
        plekerror.clear_field_errors();

        const button = jQuery('#' + type);
        const form = document.getElementById('plek-' + vob_form_name + '-form');
        const data_prepared = this.prepare_vob_data(form, type);
        //Validate the fields before sending them
        if (plekvalidator.validate_form_data(data_prepared, 'add_' + vob_form_name) !== true) {
            plekvalidator.display_errors('add_' + vob_form_name);
            return false;
        }
        plek_main.send_form(
            data_prepared,
            button,
            'plek-' + vob_form_name + '-form',
            this.send_vob_form_success,
            plek_main.form_error_callback,
            plek_main.form_systemerror_callback,
            { type: type, vob_form_name: vob_form_name }
        );
    },

    send_vob_form_success(response, button, attributes) {
        const success_message = plek_main.get_success_item_from_ajax_request(response, 'message');
        const id = plek_main.get_success_item_from_ajax_request(response, 'id');
        const preloader_data = plek_main.get_success_item_from_ajax_request(response, 'preloaded_data');
        const type = (!empty(attributes['type'])) ? attributes['type'] : null;
        const vob_form_name = (!empty(attributes['vob_form_name'])) ? attributes['vob_form_name'] : null;
        if (type === null) {
            console.error('No type given to add_new_vob_to_selection');
            return;
        }
        if (vob_form_name === null) {
            console.error('No vob_form_name given');
            return;
        }
        if (!empty(id) && !empty(preloader_data)) {
            if (typeof plekevent !== 'undefined' && !empty(id) && plek_main.is_valid_JSON(preloader_data)) {
                //Only add to selection, if the return object is the data for the preloader
                plekevent.add_new_vob_to_selection(type, id, JSON.parse(preloader_data));
                //New Band, Venue or Organizer added
                plek_main.clear_form_inputs('plek-' + vob_form_name + '-form'); //clear the form
                plek_manage_event.vob_add_to_session(id);
            }
        }
    },

    /**
     * Prepares the data before sending to the ajax handler.
     * 
     * @param {string} form HTML Form element 
     * @param {string} type Type of vob
     * @returns 
     */
    prepare_vob_data(form, type) {
        if (typeof form !== 'object') {
            return false;
        }
        var data = new FormData(form);
        switch (type) {
            case 'band-form-submit':
                data.append('action', 'plek_band_actions');
                data.append('do', 'save_band');
                var file_data = jQuery('#band-logo').prop('files')[0];
                data.append('band-description', tinymce.editors['band-description'].getContent());
                data.append('band-logo-data', file_data);
                data.append('band-logo', '666'); //This is just a placeholder for the validator to validate.
                break;
            case 'venue-form-submit':
                data.append('action', 'plek_venue_actions');
                data.append('do', 'save_venue');
                break;

            case 'organizer-form-submit':
                data.append('action', 'plek_organizer_actions');
                if (!data.has('organizer_is_festival')) {
                    data.append('organizer_is_festival', 'no');
                }
                if (!data.has('organizer_is_partner')) {
                    data.append('organizer_is_partner', 'no');
                }
                data.append('do', 'save_organizer');
                break;
            default:
                break;
        }
        return data;
    },

    /**
     * Adds the fields to the validator
     * @returns void
     */
    prepare_validator_fields() {

        var form = '';
        jQuery('form').each((index, value) => {
            form = jQuery(value).attr('id');
            //Add New Band Form
            if (form === 'plek-band-form') {
                plekvalidator.add_field('band-id', 'int', true, 'add_band');
                plekvalidator.add_field('band-name', 'text', false, 'add_band');
                plekvalidator.add_field('band-description', 'text', true, 'add_band');
                plekvalidator.add_field('band-logo-data', 'data', true, 'add_band');
                plekvalidator.add_field('band-genre', 'int', false, 'add_band');
                plekvalidator.add_field('band-origin', 'text', false, 'add_band');
                plekvalidator.add_field('band-videos', 'text', true, 'add_band');
                plekvalidator.add_field(['band-link-insta', 'band-link-fb', 'band-link-web'], 'url', true, 'add_band');
                plekvalidator.add_invalid_field_values('band-origin', ['null'], 'add_band');
                plekvalidator.add_error_messages('band-origin', 'add_band', null, null, null, null, null, __('Please select a country', 'plekvetica'));
            }
            //Add Organizer form
            if (form === 'plek-organizer-form') {
                plekvalidator.add_field('organizer-id', 'int', true, 'add_organizer');
                plekvalidator.add_field('organizer-name', 'text', false, 'add_organizer');
                plekvalidator.add_field('organizer-email', 'email', true, 'add_organizer');
                plekvalidator.add_field('organizer-phone', 'phone', true, 'add_organizer');
                plekvalidator.add_field('organizer-web', 'url', true, 'add_organizer');
            }

            //Venue form
            if (form === 'plek-venue-form') {
                plekvalidator.add_field('venue-id', 'int', true, 'add_venue');
                plekvalidator.add_field(['venue-name', 'venue-street', 'venue-city', 'venue-country'], 'text', false, 'add_venue');
                plekvalidator.add_field(['venue-province'], 'text', true, 'add_venue');
                plekvalidator.add_field('venue-zip', 'int', false, 'add_venue');
                plekvalidator.add_field('venue-phone', 'phone', true, 'add_venue');
                plekvalidator.add_field('venue-web', 'url', true, 'add_venue');
                plekvalidator.add_invalid_field_values('venue-country', ['null'], 'add_venue');
                plekvalidator.add_error_messages('venue-country', 'add_venue', null, null, null, null, null, __('Please select a country', 'plekvetica'));
            }

            //Event
            //@toto: add the form id
            if (form === 'edit_event_form') {
                plekvalidator.add_field('event_ticket_raffle_win_till', 'datetime', true, form);
                plekvalidator.add_field('event_ticket_raffle_conditions', 'int', true, form);
                plekvalidator.add_field('event_status', 'text', false, form);
                plekvalidator.add_field('event_featured', 'bool', true, form);
                plekvalidator.add_field('event_promote', 'bool', true, form);
            }

            if (form === 'add_event_basic' || form === 'edit_event_form') {
                //@5.7 - Removed, since the validation is done in the backend
                /*plekvalidator.add_field('event_name', 'text', false, form);
                plekvalidator.add_field('event_start_date', 'date', false, form);
                plekvalidator.add_field('event_band', 'int', false, form);
                plekvalidator.add_field('event_venue', 'int', false, form);
                plekvalidator.add_field('hp-password', 'honeypot', true, form);
                */
            }

            //Add the fields to the validator
            //@todo: All Event details fields should be optional
            if (form === 'add_event_details' || form === 'edit_event_form') {
                plekvalidator.add_field('event_description', 'text', true, form);
                //plekvalidator.add_field('event_organizer', 'int', true, form);
                plekvalidator.add_field('event_poster', 'file', true, form);
                plekvalidator.add_field('event_fb_link', 'url', true, form);
                plekvalidator.add_field('event_price_boxoffice', 'price', true, form);
                plekvalidator.add_field('event_price_presale', 'price', true, form);
                plekvalidator.add_field('event_currency', 'simpletext', false, form);
                plekvalidator.add_field('event_price_link', 'url', true, form);
                plekvalidator.add_field('event_id', 'int', false, form);
                plekvalidator.add_error_messages('event_id', form, __("Missing Event ID", "plekvetica"));
            }

            //Add the fields to the validator for the guest login
            if (form === 'add_event_login') {
                plekvalidator.add_field('guest_name', 'text', false, form);
                plekvalidator.add_field('guest_email', 'email', false, form);

                plekvalidator.add_field('event_id', 'int', false, form);
                plekvalidator.add_error_messages('event_id', form, __("Missing Event ID", "plekvetica"));
            }
            //Add the fields to the validator for the user login
            if (form === 'loginform') {

                plekvalidator.add_field('user_login', 'text', false, form);
                plekvalidator.add_field('user_pass', 'password', false, form);
                plekvalidator.add_field('rememberme', 'text', true, form);

                plekvalidator.add_field('event_id', 'int', false, form);
                plekvalidator.add_error_messages('event_id', form, __("Missing Event ID", "plekvetica"));
            }

        });
    },

    /**
     * On Form cancel button, the function will close the overlay, if overlay exists, otherwise it will go back to the previous site
     * For the vob (Venue, Organizer, Band) Forms
     * @param {string} button_id - Id of the button pressed
     * @returns 
     */
    vob_form_cancel(button_id) {
        if (jQuery('#' + button_id).closest(".overlay_content").length === 0) {
            //Not in overlay, go back to previous site and reload
            window.location = document.referrer;
        } else {
            //Form is in a overlay, close overlay
            let overlay_id = jQuery('#' + button_id).closest(".overlay_content").parent().prop("id");
            overlay_id = overlay_id.replace("_overlay", "");
            plektemplate.hide_overlay(overlay_id);
        }
        return;
    },
    /**
     * Add the newly created vob to the browser storage. If the user creates an account, the newly created vob will be assigned to them
     * @todo: Assign the VOB to the user
     * @param {int} vob_id The Id of the Band, Venue or Organizer added
     */
    vob_add_to_session(vob_id) {
        let existing = localStorage.getItem('plek_vob_added');
        let added = (typeof existing === 'string') ? existing + ',' + vob_id.toString() : vob_id.toString();
        localStorage.setItem('plek_vob_added', added);
    },

    /**
     * Adds the data to the selection of the form. Used on the edit Event form.
     * @param {string} json_data Json Data as a string 
     */
    add_vob_to_current_selection(type) {
        let jdata = (typeof plek_manage_event.existing_vob_data[type] === 'object') ? plek_manage_event.existing_vob_data[type] : {};
        let for_data = "";
        if (Object.keys(jdata).length === 0) {
            return;
        }
        for (const [vob_id, item] of Object.entries(jdata)) {
            switch (type) {
                case 'bands':
                    let band_item = plektemplate.load_band_item_template(item);
                    for_data = 'event-band-selection';
                    plekevent.add_item_to_selection(band_item, for_data);
                    break;
                case 'venue':
                    let venue_item = plektemplate.load_venue_item_template(item);
                    for_data = 'event-venue-selection';
                    plekevent.add_item_to_selection(venue_item, for_data);
                    break;
                case 'organizers':
                    let organizer_item = plektemplate.load_organizer_item_template(item);
                    for_data = 'event-organizer-selection';
                    plekevent.add_item_to_selection(organizer_item, for_data);
                    break;

                default:
                    break;
            }

        }
        //Check if all elements where added
        if (Object.keys(jdata).length !== document.querySelectorAll('#' + for_data + ' .item').length) {
            console.warn("Failed to add all items for: " + for_data);
        }
        if (type === 'bands') {
            //Set the flatpickr for all the band time buttons
            jQuery(document).ready(() => {
                plekevent.set_band_time_flatpickr();
            });
            //Check and remove duplicates
            //plek_remove_band_duplicates();
        }
        return;
    },
    /**
 * Adds the date to the ticket giveaway till input field
 */
    add_ticket_giveaway_date() {
        if (!empty(jQuery('#event_ticket_raffle_win_till').val())) {
            return;
        }
        const start_date = jQuery('#event_start_date').val();
        let raffle_date = new Date(start_date);
        raffle_date.setDate(raffle_date.getDate() - 10);
        let raffle_iso_date = raffle_date.toISOString().split('T');
        jQuery('#event_ticket_raffle_win_till').val(raffle_iso_date[0] + ' 12:12:00');
    },


    /**
     * Event Listener for when the user leaves the page while on the login page.
     * Logs the event with the user's inputted data.
     * @param {object} event The event triggered by the page unload
     */
    beforeUnloadPage(event) {
        let url = new URLSearchParams(window.location.search);
        if (url.get('stage') !== 'login') {
            return;
        }
        //User left the page on login screen. Log the event
        let filledData = new FormData();
        filledData.append('action', 'plek_log_action');
        filledData.append('do', 'on_user_left_page');
        filledData.append('guest_name', jQuery('#guest_name').val());
        filledData.append('guest_email', jQuery('#guest_email').val());
        filledData.append('user_login', jQuery('#user_login').val());
        navigator.sendBeacon(plek_vars.ajaxurl + "?action=plek_log_action&do=on_user_left_page", filledData)
    },

    /**
     * Checks if the social media images are uploaded.
     * If the social media images are uploaded, returns true.
     * If not, checks if any images are uploaded and if so, it returns false.
     * @returns {boolean} True if social media images are uploaded, false otherwise.
     */
    check_sm_images() {
        const smp_images = document.querySelector('.smp .image_count .nr')?.textContent;
        if (parseInt(smp_images) > 0) {
            //Social media images are uploaded, ignore check
            return true;
        }
        const all_images = document.querySelectorAll('.image_count .nr');
        let total_images = 0;
        all_images.forEach((item) => {
            total_images += parseInt(item.textContent);
        });
        if (total_images > 0) {
            return false;
        }
    },
}

/**
 * Workaround for fixing the issue that multiple bands of the same name where added.
 * @deprecated: Removed in version 4.0
 */
function plek_remove_band_duplicates() {
    var existing = {};
    const total_bands = jQuery('.item.plek-select-item').length;
    jQuery('.item.plek-select-item').each((index, item) => {
        let current = jQuery(item).data('id');
        if (existing[current] == undefined) {
            existing[current] = current;
        }
        else {
            jQuery(item).remove();
        }

    });
    console.log({ removed: (total_bands - Object.entries(existing).length), existing: Object.entries(existing).length, total: total_bands });
}
/**
 * 
 * @param {*} type
 * @todo: Replace with send form 
 */
function ajaxPreloader(type) {
    var datab = new FormData();
    datab.append('action', 'plek_ajax_event_form');
    datab.append('type', 'get_' + type);

    let inputElement = null;
    let origInputPlaceholder = null;

    //Set the status for the preloader
    if (type === 'bands') {
        inputElement = document.getElementById('event_band');
        if (inputElement !== null) {
            origInputPlaceholder = inputElement.placeholder;
            inputElement.placeholder = __('Loading bands, please wait', 'plekvetica');
        }
    } else if (type === 'venues') {
        inputElement = document.getElementById('event_venue');
        if (inputElement !== null) {
            origInputPlaceholder = inputElement.placeholder;
            inputElement.placeholder = __('Loading venues, please wait', 'plekvetica');
        }

    } else if (type === 'organizers') {
        inputElement = document.getElementById('event_organizer');
        if (inputElement !== null) {
            origInputPlaceholder = inputElement.placeholder;
            inputElement.placeholder = __('Loading organizers, please wait', 'plekvetica');
        }
    }
    if (inputElement !== null) {
        plek_main.activate_loader_style(inputElement);
        inputElement.disabled = true;
    }

    plek_main.send_form(datab, false, 'get_' + type, (response) => {
        const jdata = plek_main.get_success_item_from_ajax_request(response);
        if (!plek_main.is_valid_JSON(jdata)) {
            plekerror.display_error('', __('Failed to load %s data', 'plekvetica').replace('%s', type), __('Oh no!', 'plekvetica'))
            return false;
        }
        if (inputElement !== null) {
            inputElement.placeholder = origInputPlaceholder;
            plek_main.deactivate_loader_style(inputElement);
            inputElement.disabled = false;
        }
        const jd = JSON.parse(jdata);
        if (type === 'bands') {
            window.bandPreloadedData = jd;
            return;
        } else if (type === 'venues') {
            window.venuePreloadedData = jd;
            return;
        } else if (type === 'organizers') {
            window.organizerPreloadedData = jd;
            return;
        }
        else {
            return false;
        }
    });
    return;
}

function show_end_date() {
    jQuery('.plek-multi-date').show();
    return;
}

function hide_end_date() {
    jQuery('.plek-multi-date').hide();
    return;
}

function disable_band_input() {
    jQuery('input#event_band').prop("disabled", true);
    jQuery('.event-search-bar-container plek-button').addClass("disabled");
    jQuery('.event-search-bar-container #event_band').addClass("disabled");
    jQuery('.event-band-selection').hide();
}
function enable_band_input() {
    jQuery('input#event_band').prop("disabled", false);
    jQuery('.event-search-bar-container plek-button').removeClass("disabled");
    jQuery('.event-search-bar-container #event_band').removeClass("disabled");
    jQuery('.event-band-selection').show();
}

let plek_add_event_functions = {

    show_guest_login(element) {
        this.hide_login_containers(element);
        jQuery('#guest_login_container').show(200);
        jQuery('#add_as_guest').addClass('selected');

    },

    show_login_form(element) {
        this.hide_login_containers(element);
        jQuery('#user_login_container').show(200);
        jQuery('#add_login').addClass('selected');
    },

    hide_login_containers(element) {
        if (typeof element !== "undefined" && element.target.classList.contains('selected')) {
            switch (element.target.id) {
                case 'add_login':
                    jQuery("#guest_login_container").hide();
                    break;
                case 'add_as_guest':
                    jQuery("#user_login_container").hide();
                    break;

                default:

                    break;
            }
        } else {
            const queryParams = new URLSearchParams(window.location.search);
            if (queryParams.get("login") === null) {
                jQuery("#user_login_container").hide();
            }
            jQuery("#guest_login_container").hide();
        }
        jQuery('#add_login, #add_as_guest').removeClass('selected');
    },

    /**
     * Shows the overlay for adding a new vob
     * @param {string} type Type to display
     */
    show_vob_form(type) {
        plektemplate.hide_overlay();
        plektemplate.show_overlay(type);
        this.after_show_vob_form(type);
    },

    /**
     * Action after the vob form is displayed
     * @param {string} type The type of the vob
     */
    after_show_vob_form(type) {
        if (type === 'add-new-band') {
            //Set the band origin to null
            jQuery('#band-origin').val('NULL').trigger('change');
        }
    },
    /**
     * Sets a reminder in the localStorage.
     * 
     * @param {int} event_id The Event ID
     * @returns void
     */
    add_event_details_reminder(event_id, event_name, add_event_stage = null) {
        let reminder = new Object;
        let date = new Date;
        reminder.valid_till = date.getTime() + (1000 * 60 * 15); //Add 15 minutes to the current time
        reminder.event_id = event_id;
        reminder.name = event_name;
        reminder.stage = add_event_stage;

        if (window.localStorage.getItem('plek_event_reminder') === null) {
            let reminder_obj = {};
            reminder_obj[event_id] = reminder
            window.localStorage.setItem('plek_event_reminder', JSON.stringify(reminder_obj));
        } else {
            //There is already one object
            let existing_remember = window.localStorage.getItem('plek_event_reminder');
            try {
                let reminder_obj = JSON.parse(existing_remember);
                reminder_obj[event_id] = reminder;
                window.localStorage.setItem('plek_event_reminder', JSON.stringify(reminder_obj));
            } catch (error) {
                console.log(error);
            }
        }
        return;
    },

    /**
     * Removes the reminder from the local storage
     * @param {int} event_id 
     */
    remove_event_details_reminder(event_id, prompt = false) {
        let existing_remember = window.localStorage.getItem('plek_event_reminder');
        try {
            var reminder_obj = JSON.parse(existing_remember);
            jQuery.each(reminder_obj, (index, obj) => {
                if (obj.event_id == event_id) {
                    if (prompt) {
                        let button_text = __('You are deleting this Notification permanently. You will probably not be able to Edit this Event afterwards. Are your sure?', 'plekvetica');
                        if (confirm(button_text) === true) {
                            //Only remove if confirmed
                            delete reminder_obj[index];
                        }
                    } else {
                        delete reminder_obj[index];
                    }
                }
            });
        } catch (error) {
            console.log(error);
            return false;
        }
        //Set the remaining items
        if (empty(existing_remember)) {
            window.localStorage.removeItem('plek_event_reminder');
            return true;
        }
        window.localStorage.setItem('plek_event_reminder', JSON.stringify(reminder_obj));
        return true;
    },

    /**
     * Tries to display the reminder. If multiple reminders are set, they will be displayed at the same time.
     * @returns 
     */
    maybe_display_event_details_reminder() {
        //Ignore the function if page is a add / edit event page
        if (plek_main.page_has_event_form() || plek_main.page_has_login_form()) {
            return false;
        }

        let reminder = window.localStorage.getItem('plek_event_reminder');
        if (reminder === null) {
            return false;
        }
        try {
            let reminder_obj = JSON.parse(reminder);
            let date = new Date();
            jQuery.each(reminder_obj, (index, obj) => {
                //Delete if time is up
                if (date.getTime() > obj.valid_till) {
                    plek_add_event_functions.remove_event_details_reminder(obj.event_id);
                    return; //DOn't display the message anymore.
                }
                //Display if it is still valid
                let url = (!empty(obj.stage)) ? plek_main.event_add_page_id : plek_main.event_edit_page_id;
                let link_text = (!empty(obj.stage)) ? __('Continue with adding the Event', 'plekvetica') : __('Edit Event', 'plekvetica');
                let link_name = (!empty(obj.name)) ? link_text + ': ' + obj.name : link_text;
                let link = (!empty(obj.stage))
                    ? '<a class="fix_event_link" data-event_id= "' + obj.event_id + '" href="' + url + '?event_id=' + obj.event_id + '&stage=' + obj.stage + '">' + link_name + '</a>'
                    : '<a class="fix_event_link" data-event_id= "' + obj.event_id + '" href="' + url + '?edit=' + obj.event_id + '">' + link_name + '</a>';
                plekerror.set_toastr(
                    0,
                    true,
                    'toast-bottom-full-width',
                    () => { plek_add_event_functions.remove_event_details_reminder(obj.event_id, true); }
                );
                plekerror.display_info(__('Eventmanager Tipp', 'plekvetica'), __('The Event you added misses some details. Please add them here:', 'plekvetica') + '<br/>' + link);
                plekerror.reset_toastr();
            });

        } catch (error) {
            console.log(error);
            return false;
        }
    },

}

//Hide the containers
plek_add_event_functions.hide_login_containers();